import {useRefState} from '@startlibs/core'
import React, { useEffect, useMemo, useState } from 'react'
import _ from 'lodash/fp'
import { enums, Uploader2 } from 'uploader-frontend'
import { jwtGetFetcher, jwtPostFetcher } from '../utils/authFetch'
import {getJwt} from '../hooks/useJwt'
import {getProviderJwt, setProviderJwt} from '../hooks/useProviderJwt'
import {useNotification} from '../components/Notifications'
import { getUploaderJwt } from '../hooks/useUploaderJwt'
import { getStorageHost } from '../hooks/useStorageHost';
import { deleteMedicalRecords, downloadFiles, pdfIframeSrc, summarizeMedicalRecordsDeleteResponse, viewFileSrc } from './utils';
import { ADMIN, PATIENT } from '../enums/UserRoles';
import {lazyProviderInfo, lazyProviderInfoSec, lazyUserInfo} from '../components/WithProvider'
import { DIVISION, SUPER } from '../enums/UserRole';
import { convertToCareQualityGender } from '../enums/GenderCarequality';
import { CountryRegionData } from 'react-country-region-selector';

const apiEndpoints = {
  dicomViewer:(studies) => Promise.resolve({viewerURL:getStorageHost()+`/view/records/${studies.filter(_.get('recordUID')).map(_.get("recordUID")).join("|")}?t=${getUploaderJwt()}`}),
  nonDicomViewer: (record) => getStorageHost()+`/view/record/${record.recordUID}?t=${getUploaderJwt()}`,
  // shortTokenUrl: (requestId) => jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`,{requestId: requestId}),
  shortTokenUrl: (requestId) => {
    return requestId 
      ? jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`,{requestId: requestId})
      : jwtGetFetcher(getJwt())(`/api/shortDownloaderToken`)},
  downloadRecord: (record) => getStorageHost()+`/download/record/${record.recordUID}?t=${getUploaderJwt()}`,
  storageHost: () => getStorageHost(),
  loadDownloadRecord: (record,filename) => record.nonCompliantFiles
  ? jwtGetFetcher(getUploaderJwt())(getStorageHost()+`/download/async/nonDicoms/${record.nonCompliantFiles.map(_.get("recordUID")).join("-")}`).then(({fileUID})=> ({url:() => getStorageHost()+`/download/file/${fileUID}?t=${getUploaderJwt()}${filename ? '&originalFilename='+encodeURIComponent(filename) : ""}`}))
  : jwtGetFetcher(getUploaderJwt())(getStorageHost()+`/download/async/${record.recordUID}`).then(({fileUID})=> ({url:() => getStorageHost()+`/download/file/${fileUID}?t=${getUploaderJwt()}${filename ? '&originalFilename='+encodeURIComponent(filename) : ""}`}))
  ,
  pdfIframeSrc: (record) => pdfIframeSrc(record),
  downloadFiles: (shortJwt, records) => {downloadFiles(shortJwt, records)},
  viewFileSrc: (shortJwt, recordId) => viewFileSrc(shortJwt, recordId),
  
}


const fileFields2 = ['fileName','fileExtension','fileType','fileSize','uid','description','docType','locationFormId']
export const RecordsManagerNew = ({caseRequest = {}, autoGrouping, uploaderRef, listMode, caseId, allowReorder, disabled, setMedicalRecords, setCaseRequest, patientInfo, canOpenWorklist, isPatient, role, mode, refreshUrl, ...rest}) => {
  
  const [, setNotification] = useNotification()
  const userInfo = role === ADMIN ? lazyUserInfo.read() : {}
  const adminUserEmail = role === ADMIN ? userInfo?.login : ''
  const providerInfo = lazyProviderInfo.read()
  const providerInfoSec = role === ADMIN ? lazyProviderInfoSec.read() : null
  const medicalRecordsStore = useRefState(() => (caseRequest.medicalRecords||[]).map((file) => ({...file,...file.info})), (prev,current) => setMedicalRecords(current))
  var studyUIDList = []
  caseRequest?.medicalRecords?.map((item) => item?.info?.studyUID ? studyUIDList.push(item?.info?.studyUID) :  null)
  const [linkedStudies, setLinkedStudiesb] = useState(studyUIDList);
  const [locations, setLocations] = useState([]);

  const dob = caseRequest.patientInfo?.dob;
  let formattedDate = '';
  if (dob) {
    const parts = dob.split('-');
    if (parts.length === 3) {
      // Assuming the format is MM-DD-YYYY
      const month = parts[0].padStart(2, '0');
      const day = parts[1].padStart(2, '0');
      const year = parts[2];

      // Create the desired format YYYYMMDD
      formattedDate = `${year}${month}${day}`;

    } 
  }
  
  const getStateCode = (state, country) => {
    if(!state) return null
    if(!country) return state
    try{
      if(country === 'US' || country === 'USA' || country === 'United States' || country === 'United States of America'){
        return CountryRegionData
          .find(country => {
            return country[1] === 'US';
          })[2]
          .split("|")
          .find(st => st.split("~")[0] === state).split("~")[1];
      }else{

        return CountryRegionData
          .find(c => {
            return c[0] === country;
          })[2]
          .split("|")
          .find(st => st.split("~")[0] === state).split("~")[1];
      }
    }catch {
      return state
    }
  }

  const careQualityPatient = useMemo(() => ({
    birthDate: caseRequest.patientInfo?.dob,
    // family: caseRequest.patientInfo?.lastName,
    lastName: caseRequest.patientInfo?.lastName,
    firstName: caseRequest.patientInfo?.firstName,
    middleName: caseRequest.patientInfo?.middleName,
    // given: caseRequest.patientInfo?.firstName+" "+caseRequest.patientInfo?.middleName,
    gender: convertToCareQualityGender(caseRequest.patientInfo?.gender),
    addressLine: caseRequest.patientInfo?.address?.address,
    city: caseRequest.patientInfo?.address?.city,
    state: getStateCode(caseRequest.patientInfo?.address?.state, caseRequest.patientInfo?.address?.country),
    country: caseRequest.patientInfo?.address?.country,
    postalCode: caseRequest.patientInfo?.address?.zipCode
  }),[caseRequest.patientInfo])

  useEffect(() => {

    let refreshTimeout = -1

    // get medicarl record locations
    jwtGetFetcher(getJwt())(`/api/medicalRecordLocationForms`, {requestId:caseRequest.requestId})
      .then((response) => {
        setLocations(response.map(({id, medicalRecordLocationItem: {name}}) => ({id, name})))
      })

    if(canOpenWorklist && !isPatient){
      //let url = 'https://purviewimage.vivacloud.io/worklist/api/authenticate';
      jwtGetFetcher(getJwt())('/api/worklistToken').then((response) => {
        setProviderJwt(response.jwt);
        refreshTimeout = setInterval(() => {
          jwtGetFetcher(getJwt())('/api/worklistToken')
            .then((response) => {
              setProviderJwt(response.jwt)})
        },10*60*1000)

      })
    }
    return  () => {
      clearInterval(refreshTimeout)
      setCaseRequest(_.unset("medicalRecords"));
    }
    
  }, [])

  const setLinkedStudies = (lStudies,type,newStudy) =>{
    
    setLinkedStudiesb(lStudies);
    
    if(type == 'Add'){
      medicalRecordsStore.set(medicalRecordsStore.get().concat(newStudy));
      setMedicalRecords(medicalRecordsStore.get());
    }
  }

  const persistRecord = (record) => {
    medicalRecordsStore.set(_.unionBy(_.property('recordUID'), [record]))
    return Promise.resolve()
  }

  const persistGroups = useMemo(() => {
    let lastUpdateGroups = Promise.resolve()
    let isUpdatingGroups = false
    let nextUpdateGroups = null
    let lastGroupsContent = null
  
    const groupsAreDifferent = (newGroups) => {
      // Perform a deep comparison between lastGroupsContent and newGroups
      return JSON.stringify(lastGroupsContent) !== JSON.stringify(newGroups);
    };
  
    const syncUpdateGroup = () => {
      if (isUpdatingGroups || !groupsAreDifferent(nextUpdateGroups)) {
        return lastUpdateGroups;
      } else {
        const next = () => {
          isUpdatingGroups = true
          const currentGroups = nextUpdateGroups
          const updateGroups = (groups) => jwtPostFetcher(getUploaderJwt())(getStorageHost()+"/groups/case/"+caseId, {info: groups.filter(({transient}) => !transient)}, {method: "PUT"}).then(() => {
            // setMedicalRecords(_.set('groups.list', groups));
            if (isPatient) {
              setCaseRequest(_.set('group.info', groups));
            }
            // setCaseRequest(_.set('group.info', groups)); 
          })
          return updateGroups(currentGroups)
            .catch(e => {
              isUpdatingGroups = false
              return Promise.reject(e)
            })
            .then(() => {
              isUpdatingGroups = false
              lastGroupsContent = currentGroups
              if (currentGroups !== nextUpdateGroups) {
                syncUpdateGroup()
              }
            })
        }
        lastUpdateGroups = next()
        return lastUpdateGroups
      }
    }
    return (groups) => {
      nextUpdateGroups = groups
      return syncUpdateGroup()
    }
  }, [])

  const persistRecordInfo = (updatedRecord,currentInfo) => {

    const notesPromise = updatedRecord?.notes?.note !== currentInfo?.notes?.note
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/notes`,{note:updatedRecord?.notes?.note}, {method: 'PUT'})
      : Promise.resolve()
    const infoPromise = (!currentInfo || currentInfo.docType !== updatedRecord.docType || currentInfo.description !== updatedRecord.description)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+"/medicalRecord/info/"+updatedRecord.recordUID,{..._.pick(fileFields2,updatedRecord),type:'NonDicomFile'},{method:"PUT"})
      : Promise.resolve()

    const metaPromise = !_.isEqual(updatedRecord?.metadata,currentInfo?.metadata)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/metadata`,updatedRecord?.metadata, {method: 'PUT'})
      : Promise.resolve()

    const statePromise = (updatedRecord?.state !== currentInfo?.state && currentInfo?.state)
      ? jwtPostFetcher(getUploaderJwt())(getStorageHost()+`/record/${updatedRecord.recordUID}/state`,updatedRecord?.state, {method: 'PUT'})
      : Promise.resolve()

    return Promise.all([notesPromise,infoPromise,metaPromise,statePromise])
      .then(() =>
        medicalRecordsStore.set(_.unionBy(_.property('recordUID'), [updatedRecord]))
      )
  }

  const applyDeleteResponse = (response) => {
    const {removedIds, failures, notification} = summarizeMedicalRecordsDeleteResponse(medicalRecordsStore.get(), response)

    medicalRecordsStore.set(_.reject((record) => removedIds.includes(String(record.recordUID)), medicalRecordsStore.get()))
    if (notification) {
      setNotification(notification)
    }

    return {removedIds, failures}
  }

  const removePersistedRecord = (recordUID) => {

    const recordIds = recordUID === enums.MetaRecordType.ALL_NON_COMPLIANT_DICOM
      ? medicalRecordsStore.get().filter(record => record.format === enums.RecordFormat.NonCompliantDicom).map(_.get('recordUID'))
      : medicalRecordsStore.get().find(record => record.recordUID === recordUID)
        ? [recordUID]
        : []

    if (!recordIds.length) {
      return Promise.resolve(false)
    }

    return deleteMedicalRecords(caseRequest.requestId, recordIds).then(applyDeleteResponse)
  }

  const removeSelectedRecords = (selectedRecords) => {

    if (!selectedRecords.length) {
      return Promise.resolve({removedIds: [], failures: []})
    }

    return deleteMedicalRecords(caseRequest.requestId, selectedRecords).then(applyDeleteResponse)
  }


  return <>
    <Uploader2
      listMode={listMode}
      downloadEnabled={caseRequest}
      disabled={disabled}
      jwt={getUploaderJwt}
      apiEndpoints={apiEndpoints}
      ref={uploaderRef}
      groups={caseRequest.group?.info}
      appJwt={getUploaderJwt}
      persistRecord={persistRecord}
      persistRecordInfo={persistRecordInfo}
      removePersistedRecord={removePersistedRecord}
      removeSelectedRecords={removeSelectedRecords}
      persistGroups={persistGroups}
      setNotification={setNotification}
      medicalRecords={medicalRecordsStore.get()}
      role={isPatient ? PATIENT : role ? role : ADMIN}
      autoGrouping={autoGrouping}
      allowReorder={role === ADMIN ? true : false} 
      canMoveGroup={role === ADMIN ? true : false} 
      canAddGroup={role === ADMIN ? true : false} 
      // Those are to open Radiology Worklist
      patientName={patientInfo?.firstName+' '+patientInfo?.lastName}
      linkedStudies={linkedStudies}
      setLinkedStudies={setLinkedStudies}
      canOpenWorklist={canOpenWorklist}
      worklistViewerJwt={getJwt}
      providerJwt={getProviderJwt}
      withViewAllButton
      downloadFiles={downloadFiles}
      mode={mode}
      requestId={caseRequest.requestId}
      refreshUrl={refreshUrl}
      caseId={caseId}
      locations={locations}
      adminUserEmail={role === ADMIN ? adminUserEmail : ''}
      eveAiSettings={providerInfoSec?.eveAiSettings}
      carequalityEnabled={providerInfo?.carequalityEnabled}
      careQualityPatient={careQualityPatient}
      dicomRouterOrigin={window.DICOM_ROUTER_ORIGIN || ''}
      canRouteDicoms={
        providerInfo?.dicomRouterEnabled &&
        role === ADMIN
      }
      canCreatePacs={
        providerInfo?.dicomRouterEnabled &&
        role === ADMIN &&
        (userInfo.role === SUPER || userInfo.role === DIVISION)
      }
    />
    </>
}